import { createContext } from 'react';

type Coordinates = {
  top: number;
  left: number;
};

export interface DropdownContextValue {
  buttonRef: React.RefObject<HTMLButtonElement> | null;
  inputRef: React.RefObject<HTMLInputElement> | null;
  coords: Coordinates;
  menuRef: React.RefObject<HTMLDivElement> | null;
  hideMenu: () => void;
  showMenu: () => void;
  onToggle: (event: React.MouseEvent<HTMLElement>) => void;
  show: boolean;
  usePortal: boolean;
}

export const DropdownContext = createContext<DropdownContextValue>({
  buttonRef: null,
  inputRef: null,
  coords: {
    top: 0,
    left: 0,
  },
  menuRef: null,
  hideMenu: () => {},
  showMenu: () => {},
  onToggle: () => {},
  show: false,
  usePortal: false,
});
